<div class="product-checkout-container container-fluid py-4 px-2 px-md-4">
  <!-- Stepper / Breadcrumb -->
  <div class="row mb-4">
    <div class="col-12 d-flex justify-content-center">
      <div class="checkout-stepper d-flex align-items-center">
        <!-- Step 1: My Cart (completed/back) -->
        <div class="step cursor d-flex align-items-center" (click)="_location.back()" title="Return to cart">
          <div class="step-icon done">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
          </div>
          <span class="step-label">My Cart</span>
        </div>

        <div class="step-line active"></div>

        <!-- Step 2: Checkout (active) -->
        <div class="step active d-flex align-items-center">
          <div class="step-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>
          </div>
          <span class="step-label">Checkout</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-4">
    <!-- Left Column: Address, Payment Method, and Order Items -->
    <div class="col-lg-8">
      
      <!-- Delivery Address Section -->
      <div class="section-heading-row d-flex justify-content-between align-items-center mb-3">
        <h3 class="checkout-section-title m-0">Delivery Address</h3>
        <button *ngIf="!isLoading" type="button" class="btn-toggle-new-address d-inline-flex align-items-center gap-2" (click)="addressAddUser = !addressAddUser">
          <svg *ngIf="!addressAddUser" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
          <svg *ngIf="addressAddUser" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
          <span>{{ addressAddUser ? 'Close Form' : 'Add New Address' }}</span>
        </button>
      </div>

      <div class="checkout-card mb-4">
        <!-- Address Skeleton Loader -->
        <div class="p-3 p-md-4 border-bottom" *ngIf="isLoading">
          <div class="row g-3">
            <div class="col-md-6" *ngFor="let item of [1, 2]">
              <div class="address-box p-3 h-100 skeleton-box">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="skeleton" style="width: 50%; height: 16px;"></div>
                  <div class="skeleton" style="width: 20px; height: 20px; border-radius: 50%;"></div>
                </div>
                <div class="skeleton mb-2" style="width: 35%; height: 12px;"></div>
                <div class="skeleton mb-1" style="width: 85%; height: 12px;"></div>
                <div class="skeleton" style="width: 60%; height: 12px;"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Loaded Address List -->
        <div class="p-3 p-md-4 border-bottom" *ngIf="!isLoading">
          <div class="row g-3">
            <div *ngFor="let data of addressData" class="col-md-6">
              <div class="address-box p-3 h-100" [class.selected]="data.check" (click)="update(true, data)">
                <div class="d-flex justify-content-between align-items-start mb-2">
                  <h5 class="recipient-name m-0">{{ userData?.fullName }}</h5>
                  <div class="custom-radio" [class.active]="data.check"></div>
                </div>
                
                <p class="phone-line small text-muted mb-2 d-flex align-items-center gap-2">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                  <span>{{ userData?.phone }}</span>
                </p>

                <p class="address-text small text-muted m-0">
                  {{ data?.address }}, {{ data?.landmark }},<br>
                  {{ data?.city }}, {{ data?.state }} - <strong class="text-dark">{{ data?.pincode }}</strong>
                </p>
              </div>
            </div>
            
            <div *ngIf="addressData.length === 0" class="col-12">
              <div class="text-center p-4 bg-light rounded-3 text-muted">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="mb-2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                <p class="m-0 small">No saved addresses found. Please add a new delivery address.</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Add New Address Form Accordion -->
        <div *ngIf="addressAddUser && !isLoading" class="p-3 p-md-4 new-address-form-box">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="form-section-title m-0">Add New Delivery Address</h5>
            <span class="text-danger small fw-medium">* All fields are required</span>
          </div>

          <form [formGroup]="addressForm" class="checkout-form">
            <div class="row g-3">
              <!-- Street Address -->
              <div class="col-12">
                <div class="form-floating">
                  <textarea 
                    class="form-control" 
                    formControlName="address" 
                    id="floatingAddress" 
                    placeholder="Street Address" 
                    style="height: 85px" 
                    (keypress)="allowAddressCharacters($event)"
                    [class.is-invalid]="addressForm.get('address')?.invalid && (addressForm.get('address')?.touched || addressForm.get('address')?.dirty)"
                    [class.is-valid]="addressForm.get('address')?.valid && (addressForm.get('address')?.touched || addressForm.get('address')?.dirty)">
                  </textarea>
                  <label for="floatingAddress">Street Address / House No. <span class="text-danger">*</span></label>
                </div>
                <div class="invalid-feedback d-block" *ngIf="addressForm.get('address')?.invalid && (addressForm.get('address')?.touched || addressForm.get('address')?.dirty)">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="me-1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                  <span *ngIf="addressForm.get('address')?.hasError('required')">Street address / house number is required.</span>
                  <span *ngIf="addressForm.get('address')?.hasError('minlength')">Street address must be at least 5 characters long.</span>
                </div>
              </div>

              <!-- Pincode -->
              <div class="col-md-6">
                <div class="form-floating">
                  <input 
                    type="text" 
                    class="form-control" 
                    id="floatingPincode" 
                    placeholder="Pincode" 
                    formControlName="pincode" 
                    maxlength="6" 
                    (keypress)="numberOnly($event)"
                    [class.is-invalid]="addressForm.get('pincode')?.invalid && (addressForm.get('pincode')?.touched || addressForm.get('pincode')?.dirty)"
                    [class.is-valid]="addressForm.get('pincode')?.valid && (addressForm.get('pincode')?.touched || addressForm.get('pincode')?.dirty)">
                  <label for="floatingPincode">Pincode (6 digits) <span class="text-danger">*</span></label>
                </div>
                <div class="invalid-feedback d-block" *ngIf="addressForm.get('pincode')?.invalid && (addressForm.get('pincode')?.touched || addressForm.get('pincode')?.dirty)">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="me-1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                  <span *ngIf="addressForm.get('pincode')?.hasError('required')">Pincode is required.</span>
                  <span *ngIf="addressForm.get('pincode')?.hasError('pattern')">Please enter a valid 6-digit postal pincode.</span>
                </div>
              </div>

              <!-- Landmark -->
              <div class="col-md-6">
                <div class="form-floating">
                  <input 
                    type="text" 
                    class="form-control" 
                    id="floatingLandmark" 
                    placeholder="Landmark" 
                    formControlName="landmark" 
                    (keypress)="allowAlphaSpaceComma($event)"
                    [class.is-invalid]="addressForm.get('landmark')?.invalid && (addressForm.get('landmark')?.touched || addressForm.get('landmark')?.dirty)"
                    [class.is-valid]="addressForm.get('landmark')?.valid && (addressForm.get('landmark')?.touched || addressForm.get('landmark')?.dirty)">
                  <label for="floatingLandmark">Landmark (e.g. Near Metro Station) <span class="text-danger">*</span></label>
                </div>
                <div class="invalid-feedback d-block" *ngIf="addressForm.get('landmark')?.invalid && (addressForm.get('landmark')?.touched || addressForm.get('landmark')?.dirty)">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="me-1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                  <span>Landmark is required.</span>
                </div>
              </div>

              <!-- City -->
              <div class="col-md-4">
                <div class="form-floating">
                  <input 
                    type="text" 
                    class="form-control" 
                    id="floatingCity" 
                    placeholder="City" 
                    formControlName="city" 
                    (keypress)="allowAlphaSpaceComma($event)"
                    [class.is-invalid]="addressForm.get('city')?.invalid && (addressForm.get('city')?.touched || addressForm.get('city')?.dirty)"
                    [class.is-valid]="addressForm.get('city')?.valid && (addressForm.get('city')?.touched || addressForm.get('city')?.dirty)">
                  <label for="floatingCity">City <span class="text-danger">*</span></label>
                </div>
                <div class="invalid-feedback d-block" *ngIf="addressForm.get('city')?.invalid && (addressForm.get('city')?.touched || addressForm.get('city')?.dirty)">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="me-1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                  <span>City is required.</span>
                </div>
              </div>

              <!-- District -->
              <div class="col-md-4">
                <div class="form-floating">
                  <input 
                    type="text" 
                    class="form-control" 
                    id="floatingDistrict" 
                    placeholder="District" 
                    formControlName="district" 
                    (keypress)="allowAlphaSpaceComma($event)"
                    [class.is-invalid]="addressForm.get('district')?.invalid && (addressForm.get('district')?.touched || addressForm.get('district')?.dirty)"
                    [class.is-valid]="addressForm.get('district')?.valid && (addressForm.get('district')?.touched || addressForm.get('district')?.dirty)">
                  <label for="floatingDistrict">District <span class="text-danger">*</span></label>
                </div>
                <div class="invalid-feedback d-block" *ngIf="addressForm.get('district')?.invalid && (addressForm.get('district')?.touched || addressForm.get('district')?.dirty)">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="me-1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                  <span>District is required.</span>
                </div>
              </div>

              <!-- State -->
              <div class="col-md-4">
                <div class="form-floating">
                  <input 
                    type="text" 
                    class="form-control" 
                    id="floatingState" 
                    placeholder="State" 
                    formControlName="state" 
                    (keypress)="allowAlphaSpaceComma($event)"
                    [class.is-invalid]="addressForm.get('state')?.invalid && (addressForm.get('state')?.touched || addressForm.get('state')?.dirty)"
                    [class.is-valid]="addressForm.get('state')?.valid && (addressForm.get('state')?.touched || addressForm.get('state')?.dirty)">
                  <label for="floatingState">State <span class="text-danger">*</span></label>
                </div>
                <div class="invalid-feedback d-block" *ngIf="addressForm.get('state')?.invalid && (addressForm.get('state')?.touched || addressForm.get('state')?.dirty)">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="me-1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                  <span>State is required.</span>
                </div>
              </div>

              <!-- Country -->
              <div class="col-12">
                <div class="form-floating">
                  <input 
                    type="text" 
                    class="form-control" 
                    id="floatingCountry" 
                    placeholder="Country" 
                    formControlName="country" 
                    (keypress)="allowAlphaSpaceComma($event)"
                    [class.is-invalid]="addressForm.get('country')?.invalid && (addressForm.get('country')?.touched || addressForm.get('country')?.dirty)"
                    [class.is-valid]="addressForm.get('country')?.valid && (addressForm.get('country')?.touched || addressForm.get('country')?.dirty)">
                  <label for="floatingCountry">Country <span class="text-danger">*</span></label>
                </div>
                <div class="invalid-feedback d-block" *ngIf="addressForm.get('country')?.invalid && (addressForm.get('country')?.touched || addressForm.get('country')?.dirty)">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="me-1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                  <span>Country is required.</span>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="col-12 d-flex justify-content-end align-items-center gap-2 mt-3 pt-2 border-top">
                <button type="button" class="btn btn-sm btn-light border px-3 py-2 fw-medium rounded-pill" (click)="addressAddUser = false">
                  Cancel
                </button>
                <button type="button" class="btn-primary-action px-4 py-2" [disabled]="!addressForm.valid" (click)="addUserAddress()">
                  Save Delivery Address
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- Payment Method -->
      <h3 class="checkout-section-title mb-3">Payment Method</h3>
      <div class="checkout-card mb-4 p-3 p-md-4">
        <!-- Skeleton Payment Method -->
        <div class="row g-3" *ngIf="isLoading">
          <div class="col-md-6" *ngFor="let item of [1, 2]">
            <div class="payment-box p-3 d-flex align-items-center gap-3 skeleton-box">
              <div class="skeleton" style="width: 20px; height: 20px; border-radius: 50%;"></div>
              <div class="skeleton" style="width: 60%; height: 16px;"></div>
            </div>
          </div>
        </div>

        <!-- Loaded Payment Method -->
        <div class="row g-3" *ngIf="!isLoading">
          <div *ngFor="let data of paymentMode" class="col-md-6">
            <div class="payment-box p-3 d-flex align-items-center gap-3" 
                 [class.selected]="data.status" 
                 [class.disabled-box]="data.value !== 'COD'"
                 (click)="data.value === 'COD' ? selectPaymentMode(true, data) : null">
               <div class="custom-radio" [class.active]="data.status" [class.disabled-radio]="data.value !== 'COD'"></div>
               <span class="payment-mode-title" [ngClass]="data.value === 'COD' ? 'text-dark' : 'text-muted'">{{ data?.viewValue }}</span>
               
               <span *ngIf="data.value !== 'COD'" class="badge-disabled ms-auto">
                 Currently Unavailable
               </span>
               <span *ngIf="data.value === 'COD'" class="badge-available ms-auto">
                 Recommended
               </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Order Review -->
      <h3 class="checkout-section-title mb-3">Review Items <span *ngIf="!isLoading">({{ carts.length }})</span></h3>
      <div class="checkout-card p-3 p-md-4">
        <!-- Skeleton Order Items -->
        <div *ngIf="isLoading">
          <div *ngFor="let item of [1, 2]; let last = last" class="checkout-item-row d-flex align-items-center" [class.border-bottom]="!last" [class.mb-3]="!last" [class.pb-3]="!last">
            <div class="skeleton flex-shrink-0" style="width: 70px; height: 70px; border-radius: 8px;"></div>
            <div class="flex-grow-1 ps-3">
              <div class="skeleton mb-2" style="width: 65%; height: 16px;"></div>
              <div class="skeleton mb-2" style="width: 25%; height: 12px;"></div>
              <div class="skeleton" style="width: 35%; height: 16px;"></div>
            </div>
          </div>
        </div>

        <!-- Loaded Order Items -->
        <div *ngIf="!isLoading">
          <div *ngFor="let data of carts; let i = index; let last = last" class="checkout-item-row d-flex align-items-center" [class.border-bottom]="!last" [class.mb-3]="!last" [class.pb-3]="!last">
            <div class="checkout-img-wrap flex-shrink-0">
              <img [src]="data?.url || 'assets/img/image_not_available.png'" [alt]="data?.productName" loading="lazy">
            </div>

            <div class="flex-grow-1 ps-3">
              <h5 class="checkout-product-title mb-1">{{ data?.productName }}</h5>
              <p class="text-muted small mb-1">Quantity: <strong class="text-dark">{{ data?.quantity }}</strong></p>
              <div class="d-flex align-items-baseline gap-2 flex-wrap">
                <span class="current-price">₹{{ data?.productPrice }}</span>
                <span class="mrp-price text-muted small" *ngIf="data?.productMRP && data.productMRP != data.productPrice">
                  ₹{{ data?.productMRP }}
                </span>
                <span class="discount-pill" *ngIf="data?.offPercentage">
                  {{ data?.offPercentage }}% Off
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column: Order Summary -->
    <div class="col-lg-4">
      <!-- Skeleton Order Summary -->
      <div class="summary-card" *ngIf="isLoading">
        <div class="p-4">
          <div class="skeleton mb-4" style="width: 50%; height: 20px;"></div>
          
          <div class="d-flex justify-content-between mb-3" *ngFor="let line of [1, 2, 3, 4]">
            <div class="skeleton" style="width: 45%; height: 14px;"></div>
            <div class="skeleton" style="width: 25%; height: 14px;"></div>
          </div>

          <div class="border-top pt-3 mb-4 d-flex justify-content-between align-items-center">
            <div class="skeleton" style="width: 35%; height: 18px;"></div>
            <div class="skeleton" style="width: 30%; height: 24px;"></div>
          </div>

          <div class="skeleton mb-3" style="width: 100%; height: 40px; border-radius: 8px;"></div>
          <div class="skeleton w-100 mb-3" style="height: 48px; border-radius: 9999px;"></div>
          <div class="skeleton w-100" style="height: 44px; border-radius: 12px;"></div>
        </div>
      </div>

      <!-- Loaded Order Summary -->
      <div class="summary-card sticky-top" style="top: 90px;" *ngIf="!isLoading">
        <div class="p-4">
          <h3 class="summary-card-title mb-3 pb-2 border-bottom">Order Summary</h3>
          
          <div class="summary-line">
            <span class="summary-label">Subtotal ({{ totalItems }} items)</span>
            <span class="summary-value">₹{{ totalAmounts }}</span>
          </div>

          <div class="summary-line">
            <span class="summary-label">Discount</span>
            <span class="summary-value text-success">- ₹{{ discountAmounts }}</span>
          </div>

          <div class="summary-line">
            <span class="summary-label">Delivery</span>
            <span class="summary-value text-success">{{ deliverCharges === 0 ? 'FREE' : '₹' + deliverCharges }}</span>
          </div>

          <div class="summary-line border-bottom pb-3 mb-3">
            <span class="summary-label">Platform Fee</span>
            <span class="summary-value">₹{{ plateformFee }}</span>
          </div>
          
          <div class="summary-total-row mb-3">
            <span class="total-label">Total Payable</span>
            <span class="total-val">₹{{ grandTotal }}</span>
          </div>
          
          <div class="savings-alert text-center mb-4 p-2 d-flex align-items-center justify-content-center gap-2">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
            <span class="fw-semibold">You save ₹{{ discountAmounts }} on this order</span>
          </div>

          <button type="button" class="btn-primary-action w-100 py-3 mb-3 d-flex justify-content-center align-items-center gap-2" (click)="orderPlaced()">
            <span>Confirm & Place Order</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
          </button>

          <div class="trust-badge-wrap d-flex align-items-center justify-content-center gap-2 p-3">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><polyline points="9 12 11 14 15 10"></polyline></svg>
            <p class="m-0 text-muted small fw-medium">
              100% Secure & Encrypted Checkout
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>